export default `
§ achievements.commitsAfter1500.title: 부엉이
§ achievements.commitsAfter1500.description: 15:00 이후 70%커밋
§ achievements.commitsBefore1500.title: 이른 새
§ achievements.commitsBefore1500.description: 점심 전에 커밋의 70%
§ achievements.workEveryTime.title: 하나님의 종
§ achievements.workEveryTime.description: 하루 중 매 시간마다 약속이 있습니다.
§ achievements.workNotWork.title: 공백이 있습니다
§ achievements.workNotWork.description: 커밋하지만 닫힌 작업은 없습니다
§ achievements.userNotWork.title: 길 잃은
§ achievements.userNotWork.description: 그의 주요 프로젝트가 아닙니다
§ achievements.userIsDied.title: 죽은 영혼
§ achievements.userIsDied.description: 근무,하지만 종료
§ achievements.lessTasks.title: 안으로 그리고 밖으로
§ achievements.lessTasks.description: 입력 및 종료된 닫힌 작업 수가 가장 적습니다
§ achievements.moreTasks.title: 아빠 그릿 말라츠아
§ achievements.moreTasks.description: 대부분의 모든 폐쇄 작업
§ achievements.everyMessageLong.title: 웅변의 마스터
§ achievements.everyMessageLong.description: 일관되게 가장 긴 커밋 서명이 있습니다.
§ achievements.everyMessageShort.title: 수다쟁이는 간첩을 위한 신의 선물이다
§ achievements.everyMessageShort.description: 일관되게 가장 짧은 커밋 서명
§ achievements.shortestName.title: 크기는 주요 아닙니다
§ achievements.shortestName.description: 것,가장 짧은 이름
§ achievements.longestName.title: 아지미 아지즈 일 암 카디르 이므란 2 세
§ achievements.longestName.description: 가장 긴 이름입니다.
§ achievements.moreCommits.title: 백업 마법사
§ achievements.moreCommits.description: 가장 많은 커밋이 있습니다
§ achievements.lessCommits.title: 드물지만 적절하게
§ achievements.lessCommits.description: 최소 커밋
§ achievements.oneCommitOneTask.title: 정확히 목표에
§ achievements.oneCommitOneTask.description: ,평균적으로 작업 당 하나의 커밋
§ achievements.moreLazyDays.title: 정신적으로,나는 당신과 함께 있습니다
§ achievements.moreLazyDays.description: 커밋 없는 대부분의 날
§ achievements.lessLazyDays.title: 파파 카를로
§ achievements.lessLazyDays.description: 커밋 없이 최소 일 수 있음
§ achievements.zeroLazyDays.title: 단 한 번의 휴식도
§ achievements.zeroLazyDays.description: ,커밋 없이 단 하루도
§ achievements.moreWorkDays.title: 소중한 직원
§ achievements.moreWorkDays.description: 최대 작업 일을 위해
§ achievements.moreScopes.title: 시작
§ achievements.moreScopes.description: 대부분의 기능을 만들었습니다
§ achievements.lessScopes.title: 골드핀치
§ achievements.lessScopes.description: 가장 적은 기능을 만들었습니다.
§ achievements.moreDaysForTask.title: 슬로프에 달팽이
§ achievements.moreDaysForTask.description: 작업 작업은 나머지 작업보다 느립니다
§ achievements.more2DaysForTask.title: 느린
§ achievements.more2DaysForTask.description: ,작업 당 2 일 이상
§ achievements.more3YearsInProject.title: 그는 오래 된 타이머 되었습니다
§ achievements.more3YearsInProject.description: 3 년 이상 프로젝트에서
§ achievements.lessDaysInProject.title: 그리고 이것은 누구입니까?
§ achievements.lessDaysInProject.description: 프로젝트의 최소 일 수
§ achievements.lessDaysForTask.title: 빠른
§ achievements.lessDaysForTask.description: 화재 한 작업은 하루 미만 소요
§ achievements.adam.title: 아담
§ achievements.adam.description: 프로젝트의 첫 번째 안정적인 직원
§ achievements.more90DaysInProject.title: 환영
§ achievements.more90DaysInProject.description: 집행유예로 해고되지 않음
§ achievements.more365DaysInProject.title: 고도바시크
§ achievements.more365DaysInProject.description: 이 프로젝트에서 1 년 동안 일했습니다.
§ achievements.more666DaysInProject.title: 젠장
§ achievements.more666DaysInProject.description: ,나는 프로젝트에 666 일을 일했다
§ achievements.more777DaysInProject.title: 아지노 3 축
§ achievements.more777DaysInProject.description: 프로젝트에 777 일 근무
§ achievements.moreDaysInProject.title: 팀의 일부,배의 일부
§ achievements.moreDaysInProject.description: 프로젝트에 가장 많은 일
§ achievements.moreRefactoring.title: 릴리스 편집기
§ achievements.moreRefactoring.description: 모든 레이블"리팩토링"을 최대한 활용했습니다.
§ achievements.longestMessage.title: "혀로 말하기"가방이 아닌 롤
§ achievements.longestMessage.description: 모든 시간 중 가장 긴 커밋 서명 이상
§ achievements.moreTasksInDay.title: 스피디 레이서
§ achievements.moreTasksInDay.description: 하루 종료된 작업 수에 대한 레코드입니다
§ achievements.hasCommitFrom0to7.title: 야간 시계
§ achievements.hasCommitFrom0to7.description: 밤의 모든 시간에 대한 커밋이있다
§ achievements.noCommitOnDay.title: 기술 중단
§ achievements.noCommitOnDay.description: 결코 오지 않는 근무 시간 도중 어느 시간 및 일이 있다
§ achievements.hasCommitEveryTime.title: 직장에서 사망
§ achievements.hasCommitEveryTime.description: 매일 한 시간 동안 커밋이 있습니다(주말 포함)
§ achievements.commitsAfter1800.title: 영업 시간
§ achievements.commitsAfter1800.description: ,18:00 이후에는 커밋이 없습니다
§ achievements.moreFix.title: 버그 헌터
§ achievements.moreFix.description: 가장 닫힌 버그가 있습니다
§ achievements.lessWorkDays.title: 그럼
§ achievements.lessWorkDays.description: 나 없이 더 적은 작업 일이 있다
§ achievements.moreCreateCode.title: 창조주
§ achievements.moreCreateCode.description: 코드를 추가하는 다른 사람보다 더 많은 경향이있다
§ achievements.moreRemoveCode.title: 파괴자
§ achievements.moreRemoveCode.description: 코드를 삭제하는 다른 사람보다 더 많은 경향이있다
§ achievements.moreChangeCode.title: 개혁자
§ achievements.moreChangeCode.description: 코드를 변경하는 다른 사람보다 더 많은 경향이있다
§ achievements.moreStyle.title: 패션 경찰
§ achievements.moreStyle.description: 다른 사람들보다 더 많은 경향이 있습니다.
§ achievements.moreOnHoliday.title: 생명 은 없다
§ achievements.moreOnHoliday.description: 시간 이후 비교적 많은 커밋의 경우
§ achievements.morePRMerge.title: 세관은 이동-미리 제공
§ achievements.morePRMerge.description: 다른 사람들보다 더 자주 그는 홍보를 위해"부어"버튼을 누릅니다
§ achievements.longWaitPR.title: 내일,확실히
§ achievements.longWaitPR.description: ,우리는 한 달 이상 검토에 매달려 된 홍보를 만들 것입니다
§ achievements.moreLongWaitPR.title: 오래 전,먼 은하에서
§ achievements.moreLongWaitPR.description: ,나는 가능한 한 오랫동안 리뷰에 매달린 홍보를 만들었습니다
§ achievements.oneExtension.title: 전장에서 유일한 사람은 전사입니다
§ achievements.oneExtension.description: ,그는 특정 확장자의 파일 만 사용합니다
§ achievements.fileRush.title: 저그 러쉬
§ achievements.fileRush.description: 프로젝트에서 가장 많은 파일을 만들었습니다.
§ achievements.moreLintHint.title: 그라마르-나치
§ achievements.moreLintHint.description: 생성 또는 코드의 자동 검증의 규칙에 가장 변경
§ achievements.moreReadMe.title: 연대기 작가
§ achievements.moreReadMe.description: 가장 많이 만든 파일 또는 변경된 파일
§ achievements.moreDevOps.title: 개발 운영
§ achievements.moreDevOps.description: 가장 많은 파일을 생성 또는 수정했습니다.
§ achievements.moreTests.title: 테스터
§ achievements.moreTests.description: 테스트를 위해 가장 많은 파일을 만들거나 수정했습니다
§ achievements.allRelease.title: 풀 하우스
§ achievements.allRelease.description: 그의 작업에서만 컴파일 된 릴리스가 있습니다
§ achievements.firstCommit.title: 누가 첫 번째,그리고 운동화
§ achievements.firstCommit.description: 프로젝트의 첫 번째 커밋입니다
§ achievements.lastCommit.title: 나는 완료
§ achievements.lastCommit.description: 프로젝트의 마지막 커밋
§ achievements.firstLastCommit.title: 처음부터 끝까지
§ achievements.firstLastCommit.description: ,프로젝트의 첫 번째와 마지막 커밋
§ achievements.longFilePath.title: 조국의 쓰레기통
§ achievements.longFilePath.description: 가장 깊은 첨부 파일을 만든 첫 번째 사람
§ achievements.longFileName.title: 크기 문제
§ achievements.longFileName.description: 가장 긴 이름을 가진 파일을 만들었습니다.
§ achievements.workOnWeekends.title: 일 은 산책 이 아니다
§ achievements.workOnWeekends.description: 적어도 한 번 주말에 일했다
§ achievements.removeCreateFile.title: 나는 스튜어디스를 발굴
§ achievements.removeCreateFile.description: 그리고 삭제 된 파일을 복원
§ achievements.renameFile.title: 아스타나 누르 술탄 아스타나
§ achievements.renameFile.description: 파일 이름을 앞뒤로 바꿉니다
§ achievements.longTask.title: 이즈얀
§ achievements.longTask.description: 3 개월 이상 작업을 해왔습니다.
§ achievements.haveNotEmail.title: 우편사 페치킨
§ achievements.haveNotEmail.description: 전자 메일 필드를 채우지 않았습니다.
§ achievements.moreAddedFolders.title: 이사
§ achievements.moreAddedFolders.description: 가장 많은 디렉토리를 만들었습니다.
§ achievements.horoscope1.title: 염소 자리의 역행 수은
§ achievements.horoscope2.title: 물병 자리의 역행 수성
§ achievements.horoscope3.title: 물고기의 역행 수은
§ achievements.horoscope4.title: 양자리의 역행 수은
§ achievements.horoscope5.title: 황소 자리의 역행 수은
§ achievements.horoscope6.title: 쌍둥이 자리의 역행 수성
§ achievements.horoscope7.title: 암의 역행 수은
§ achievements.horoscope8.title: 레오의 역행 수성
§ achievements.horoscope9.title: 처녀 자리의 역행 수성
§ achievements.horoscope10.title: 천칭 자리의 역행 수은
§ achievements.horoscope11.title: 전갈 자리의 역행 수성
§ achievements.horoscope12.title: 궁수 자리의 역행 수은
§ achievements.horoscope1.description: 첫 번째 약속의 달까지
§ achievements.horoscope2.description: 첫 번째 약속의 달까지
§ achievements.horoscope3.description: 첫 번째 약속의 달까지
§ achievements.horoscope4.description: 첫 번째 약속의 달까지
§ achievements.horoscope5.description: 첫 번째 약속의 달까지
§ achievements.horoscope6.description: 첫 번째 약속의 달까지
§ achievements.horoscope7.description: 첫 번째 약속의 달까지
§ achievements.horoscope8.description: 첫 번째 약속의 달까지
§ achievements.horoscope9.description: 첫 번째 약속의 달까지
§ achievements.horoscope10.description: 첫 번째 약속의 달까지
§ achievements.horoscope11.description: 첫 번째 약속의 달까지
§ achievements.horoscope12.description: 첫 번째 약속의 달까지
§ achievements.111.description: 시험
`;
